module.exports = __webpack_public_path__ + "static/media/flowplayer-logo.7d336e96.png";